var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/279ba707534ab1d1ff9687cde0a3f373.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f247687bde6ab983413c9f1ee11dd8f6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    